import React from 'react';

const AddVendor =React.lazy(()=>import('./AddVendor'));
const VendorList =React.lazy(()=>import('./VendorList'));
const VendorDetailPage =React.lazy(()=>import('./VendorDetailPage'));
const VendorProject =React.lazy(()=>import('./VendorProject'));
export {
    AddVendor,
    VendorList,
    VendorDetailPage,
    VendorProject
}